import { render, staticRenderFns } from "./Scaler.vue?vue&type=template&id=deda59a2"
import script from "./Scaler.vue?vue&type=script&lang=ts"
export * from "./Scaler.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports